module.exports = __webpack_public_path__ + "img/green-apple.559b3301.png";